export default () => {

  // const map = document.querySelector('.se-map__map');
  // if (!map) return;

  // // data-current からデフォルト hover を付ける関数
  // const applyDefaultHover = () => {
  //   const current = map.dataset.current;
  //   if (!current) return;

  //   document
  //     .querySelectorAll(`.point-${current}, .group-${current}`)
  //     .forEach(el => el.classList.add('is-hover'));
  // };

  // // すべての hover を外す
  // const clearHover = () => {
  //   document
  //     .querySelectorAll('.point.is-hover, .group.is-hover')
  //     .forEach(el => el.classList.remove('is-hover'));
  // };

  // // 初期状態
  // applyDefaultHover();

  // // hover発火点だけ取得
  // const areas = document.querySelectorAll('.point .point-area');

  // areas.forEach(area => {

  //   const point = area.closest('.point');
  //   if (!point) return;

  //   const keyClass = Array.from(point.classList).find(c =>
  //     c.startsWith('point-')
  //   );
  //   if (!keyClass) return;

  //   const key = keyClass.replace('point-', '');

  //   const targets = document.querySelectorAll(
  //     `.point-${key}, .group-${key}`
  //   );

  //   const onEnter = () => {
  //     clearHover();
  //     targets.forEach(t => t.classList.add('is-hover'));
  //   };

  //   const onLeave = () => {
  //     clearHover();
  //     applyDefaultHover();
  //   };

  //   area.addEventListener('mouseenter', onEnter);
  //   area.addEventListener('mouseleave', onLeave);
  // });

  if(document.querySelector('.se-map')){
    const mapWrap = document.querySelector('.se-map-wrap');
    const defaultCode = mapWrap?.dataset.mapCurrent?.toLowerCase();

    // 初期状態：current を反映
    const setCurrent = () => {
      if (!defaultCode) return;

      document
        .querySelectorAll('.js-map-target')
        .forEach(el => el.classList.remove('is-hover'));

      document
        .querySelectorAll(`.js-map-target.is-${defaultCode}`)
        // .forEach(el => el.classList.add('is-hover'));
        .forEach(el => el.classList.add('is-hover'));

      document
        .querySelectorAll(`.js-map-target.is-${defaultCode}`)
        .forEach(el => el.classList.add('is-current'));
    };

    // hover を全解除
    const clearHover = () => {
      document
        .querySelectorAll('.js-map-target.is-hover')
        .forEach(el => el.classList.remove('is-hover'));
    };

    setCurrent();

    // hover 処理
    document.querySelectorAll('.js-path-link').forEach(link => {
      link.addEventListener('mouseenter', () => {
        clearHover();

        link.classList.forEach(cls => {
          const match = cls.match(/^is-target-([a-z]{2})$/);
          if (!match) return;

          const code = match[1];
          document
            .querySelectorAll(`.js-map-target.is-${code}`)
            .forEach(el => el.classList.add('is-hover'));
        });
      });

      link.addEventListener('mouseleave', () => {
        clearHover();
        setCurrent(); // デフォルトに戻す
      });
    });
  }
};
